import styled from 'styled-components';

export default styled.section`
  padding: 1.375rem ${props => props.theme.padding.inner} 2.125rem;

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: 4.25rem ${props => props.theme.padding.inner} 5.875rem;
  }

  > .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
      display: flex;
      flex-direction: row;
    }

    > .content {
      width: auto;
    }
  }

  .menu {
    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      width: 100%;
      max-width: ${props => props.theme.maxWidths.faqsMenu};
      margin-right: 1rem;
      margin-top: 0.5rem;
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transition: all 0.4s ease-in-out;
        transform: translateX(-10px);
      }
    }

    .active& {
      opacity: 1;
      transform: none;
    }

    ul {
      display: none; /* Hide by default for mobile */
      flex-direction: row;
      margin: 0;
      padding: 0;
      list-style: none;

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        display: flex; /* Show on desktop */
        flex-direction: column;
      }

      li {
        margin: 0;
        padding: 0;

        &:nth-child(2) {
          a {
            padding-top: 0.25rem;
          }
        }

        &:last-child {
          a {
            padding-bottom: 0;
          }
        }

        a {
          display: none;
          transition: all 0.4s ease-in-out;

          @media (min-width: ${props => props.theme.breakpoints.desktop}) {
            display: block;
            color: ${props => props.theme.colors.bedtime};
            text-decoration: none;
            font-size: ${props => props.theme.type.h5};
            line-height: ${props => props.theme.lineHeights.h5};
            letter-spacing: ${props => props.theme.letterSpacing.h5};
            font-family: ${props => props.theme.fonts.primary};
            font-weight: 800;
            padding: 1rem 0;
          }

          &:focus,
          &:active,
          &:hover {
            transform: translateX(10px);
          }

          &.active {
            display: block;
            margin-left: 0.5rem;
            color: ${props => props.theme.colors.grey1};
            text-decoration: none;

            @media (min-width: ${props => props.theme.breakpoints.desktop}) {
              margin-left: 0;
              color: ${props => props.theme.colors.claytonBlue};
            }

            &:focus,
            &:active,
            &:hover {
              transform: none;
            }
          }
        }
      }
    }
  }

  .content {
    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      margin-right: 6.5rem;
    }

    *[class*='block'] {
      padding-left: 0;
      padding-right: 0;

      &:first-child {
        padding-top: 0;

        @media (min-width: ${props => props.theme.breakpoints.desktop}) {
          h2 {
            margin-top: 0;
          }
        }
      }

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
`;
